import { render, staticRenderFns } from "./FeedFollow.vue?vue&type=template&id=d5a03502&scoped=true&"
import script from "./FeedFollow.vue?vue&type=script&lang=js&"
export * from "./FeedFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a03502",
  null
  
)

export default component.exports